import type { ChangeEvent, FC } from 'react';
import { Box, Flex } from '@eqi-investimentos/react';
import { Icon } from '@/components/elements/Icon';
import { PlayerButton } from './Button';

export const Volume: FC<VolumeProps> = ({ volume, onToggle, onSeek }) => (
  <Flex
    position="relative"
    justifyContent="center"
    _hover={{ '& .range': { transform: 'scaleY(1)' } }}
  >
    <PlayerButton onClick={onToggle}>
      <Icon
        iconName={volume > 0 ? 'VolumeOnOutline' : 'VolumeOffOutline'}
        color="content.alwaysLight"
      />
    </PlayerButton>
    <Flex
      className="range"
      position="absolute"
      alignItems="flex-end"
      bottom="calc(2rem + 30%)"
      w="0.5rem"
      h="6rem"
      transform="scaleY(0)"
      transformOrigin="bottom"
      transition="transform 200ms ease-out"
      _hover={{
        '& .thumb': {
          transform: 'translateX(50%) scale(1)',
        },
      }}
    >
      <Box
        bg="content.secondary"
        position="absolute"
        w="full"
        h="full"
        borderRadius="m"
      />
      <Box
        position="relative"
        bg="content.brandLight"
        w="full"
        h={`${volume * 100}%`}
        borderRadius="m"
      >
        <Box
          className="thumb"
          position="absolute"
          top="-0.75rem"
          right="50%"
          w="1.5rem"
          h="1.5rem"
          borderRadius="50%"
          bg="content.brandLight"
          transform="translateX(50%) scale(0)"
          transition="transform 200ms ease-out"
        />
      </Box>
      <input
        type="range"
        value={volume}
        max="1"
        step="0.05"
        onChange={onSeek}
        style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          borderRadius: '50px',
          cursor: 'pointer',
          opacity: '0',
          writingMode: 'vertical-lr',
          direction: 'rtl',
          verticalAlign: 'top',
        }}
      />
    </Flex>
  </Flex>
);

type VolumeProps = {
  volume: number;
  onToggle: () => void;
  onSeek: (event: ChangeEvent<HTMLInputElement>) => void;
};
